var _rect, _rect2, _rect3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2575",
    "data-name": "Group 2575",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.008,
    height: 23.376,
    viewBox: "0 0 19.008 23.376",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1379",
    "data-name": "Rectangle 1379",
    width: 1.839,
    height: 1.839,
    transform: "translate(2.643 7.133)",
    fill: "#22c"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1380",
    "data-name": "Rectangle 1380",
    width: 1.839,
    height: 1.84,
    transform: "translate(2.643 2.292)",
    fill: "#22c"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1381",
    "data-name": "Rectangle 1381",
    width: 1.839,
    height: 1.839,
    transform: "translate(2.643 11.974)",
    fill: "#22c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8209",
    "data-name": "Path 8209",
    d: "M6.553,12.531H17.089v.725H6.553ZM1.92,11.249H5.207v3.287H1.92ZM6.553,7.691H17.089v.725H6.553ZM1.92,6.409H5.207V9.7H1.92ZM6.553,2.851H17.089v.724H6.553ZM1.92,1.569H5.207V4.855H1.92ZM0,23.376H19.008V0H0Z",
    fill: "#22c"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.f61f8619cc47336879407a75c91c65c9.svg";
export { ForwardRef as ReactComponent };